import { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';

import style from './SupportWidget.module.scss';

import { translate } from '@chaika/i18n/helper';

const EMOJIS = [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🙂',
    '😉',
    '😊',
    '😇',
    '🥰',
    '😍',
    '😘',
    '😋',
    '😎',
    '🤓',
    '🤔',
    '🤗',
    '🤝',
    '😐',
    '😑',
    '😶',
    '🙄',
    '😏',
    '😬',
    '😌',
    '😔',
    '😪',
    '😴',
    '😷',
    '🤒',
    '🤕',
    '🥴',
    '😵',
    '🤯',
    '😕',
    '😟',
    '🙁',
    '😮',
    '😯',
    '😲',
    '😳',
    '🥺',
    '😢',
    '😭',
    '😱',
    '😤',
    '😡',
    '🤬',
    '👍',
    '👎',
    '👌',
    '✌️',
    '🤞',
    '👏',
    '🙌',
    '🙏',
    '💪',
    '👋',
    '❤️',
    '💔',
    '🔥',
    '⭐',
    '✨',
    '🎉',
    '✅',
    '❌',
    '⚠️',
    '❓',
    '❗',
    '💡',
    '📎',
    '📄',
    '📅',
    '⏰',
    '📞',
    '💊',
    '🩺',
    '🏥',
];

interface Props {
    isDisabled: boolean;
    onSelect(emoji: string): void;
}

export function EmojiPicker({ isDisabled, onSelect }: Props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Popover.Root
            open={isOpen}
            onOpenChange={setIsOpen}
        >
            <Popover.Trigger asChild>
                <button
                    className={style.composerIconButton}
                    type={'button'}
                    disabled={isDisabled}
                    aria-label={translate('supportEmoji')}
                    title={translate('supportEmoji')}
                >
                    <span aria-hidden={'true'}>🙂</span>
                </button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    className={style.popover}
                    side={'top'}
                    align={'start'}
                    sideOffset={4}
                    aria-label={translate('supportEmoji')}
                    onCloseAutoFocus={event => event.preventDefault()}
                >
                    <div className={style.emojiGrid}>
                        {EMOJIS.map(emoji => (
                            <button
                                key={emoji}
                                className={style.emojiButton}
                                type={'button'}
                                onClick={() => {
                                    onSelect(emoji);
                                    setIsOpen(false);
                                }}
                            >
                                {emoji}
                            </button>
                        ))}
                    </div>
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
}
